export const OtpTypes = {
  PHONE: 'Phone',
  EMAIL: 'Email',
  PASSWORD: 'Password',
};
